import {
  createBlock,
  mergeBlock,
  NodeUtils,
  t,
} from "@easy-email-pro-core/utils";

import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  StandardTable2TdElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BasicBlock } from "@easy-email-pro-core/components/BasicBlock";
import { ContentLeaf } from "@easy-email-pro-core/components/ContentLeaf";
import { BlockRenderer } from "@easy-email-pro-core/components";

const defaultData: ElementDefinition<StandardTable2TdElement>["defaultData"] = {
  attributes: {},
  data: {
    rowspan: 1,
    colspan: 1,
  },
};

export const StandardTable2Td = createBlock<StandardTable2TdElement>({
  get name() {
    return t("Table Td");
  },
  void: false,
  defaultData,
  type: StandardType.STANDARD_TABLE2_TD,
  create: (payload) => {
    const defaultData: StandardTable2TdElement = {
      type: StandardType.STANDARD_TABLE2_TD,
      data: {
        rowspan: 1,
        colspan: 1,
      },
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.TABLE2_TD,
  render(params) {
    const { node } = params;

    const styles = [] as string[];
    const attributes = node.attributes;

    if (attributes["border-enabled"]) {
      styles.push(
        `border:  ${attributes["border-width"]} ${attributes["border-color"]} ${attributes["border-style"]}`
      );
    }
    if (attributes["text-align"]) {
      styles.push(`text-align:  ${attributes["text-align"]}`);
    }
    return (
      <BasicBlock
        params={{
          ...params,
          node: {
            ...node,
            attributes: {
              style: styles.join(";"),
              rowspan: node.data.rowspan?.toString() || "1",
              colspan: node.data.colspan?.toString() || "1",
            } as any,
          },
        }}
        tag="td"
        children={node.children.map((item, index) => {
          if (NodeUtils.isTextNode(item)) {
            return <ContentLeaf key={index} node={item} />;
          }
          return <BlockRenderer key={index} node={item} />;
        })}
      />
    );
  },
});
